// L0-02/L0-03: system-aware 主题引导（自 root.html.heex 内联 script 迁移）。
// 逻辑与 web 版（apps/deepblue_web/assets/js/theme.js）一致，按 M1 决策两 app 各自维护，勿合并。
// <html> 上的 data-theme="light" 是无 JS 兜底；本模块在 app.js 导入后立即覆盖为系统/用户偏好。
const systemTheme = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
const setTheme = (theme) => {
	document.documentElement.classList.add("disable-transitions");
	if (theme === "system") {
		localStorage.removeItem("phx:theme");
		document.documentElement.setAttribute("data-theme", systemTheme());
		document.documentElement.setAttribute("data-theme-source", "system");
	} else {
		localStorage.setItem("phx:theme", theme);
		document.documentElement.setAttribute("data-theme", theme);
		document.documentElement.setAttribute("data-theme-source", "user");
	}
	// Force reflow to flush styles before removing the helper class
	const _unused = document.documentElement.offsetHeight;
	window.requestAnimationFrame(() => {
		window.requestAnimationFrame(() => {
			document.documentElement.classList.remove("disable-transitions");
		});
	});
};
// html 已有静态 data-theme（兜底）时仍强制按偏好覆盖
setTheme(localStorage.getItem("phx:theme") || "system");
window.addEventListener("storage", (e) => {
	if (e.key === "phx:theme") setTheme(e.newValue || "system");
});
window.addEventListener("phx:set-theme", (e) => setTheme(e.target.dataset.phxTheme));
window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
	if (document.documentElement.getAttribute("data-theme-source") === "system") {
		document.documentElement.setAttribute("data-theme", systemTheme());
	}
});
